import React, {useEffect} from 'react';
import ReactDOM from "react-dom";
import Marquee from "react-fast-marquee";
import "./PromoMarquee.style.scss";
import Currency from "../../components/Currency/Currency";
import {useNavigate} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import GlobalConst from "../../constants/GlobalConst";
import {useSelector} from "react-redux";
import {selectUserAccount} from "../../stores/account/account.selectors";
import useAppModalService from "../../hooks/useAppModalService";
import SecureDepositPopUp from "../PopUps/SecureDepositPopUp/SecureDepositPopUp";
import {ModalType} from "../../components/AppModal/ModalTypes";

const PROMO_CODE = "promo-double-deposit";

const PromoMarquee = () => {
    const navigate = useNavigate();
    const userAccount = useSelector(selectUserAccount);
    const {openModal} = useAppModalService();

    const handlePromoClick = () => {
        if (userAccount) {
            if (GlobalConst.FEATURES.ADD_FUNDS)
                openModal('deposit', ModalType.CUSTOM, {
                    title: 'Secure Deposit',
                    modalComponent: SecureDepositPopUp,
                });
        } else {
            navigate("/register?promoCode=" + PROMO_CODE);
        }
    };

    const msg = <div className={"promo-double-deposit"}
                     onClick={handlePromoClick}>
        <FormattedMessage id={"promo.doubleDeposit.marquee"}
                          values={{
                              promoCode: (x) => <b>{x}</b>,
                              currency: (_) => <Currency value={GlobalConst.PROMO.DOUBLE_DEPOSIT.AMOUNT}
                                                         currency={GlobalConst.SITE_CURRENCY}/>
                          }}
        />
    </div>;
    const spacer = <div className={"spacer"}>&ndash;</div>;

    useEffect(() => {
        document.body.classList.add("promo-marquee");
        return () => {
            document.body.classList.remove("promo-marquee");
        }
    }, []);

    return ReactDOM.createPortal(<div className={"PromoMarquee"}>
        <Marquee pauseOnHover={true}
                 speed={50}>
            {msg}{spacer}{msg}{spacer}{msg}{spacer}
        </Marquee>
    </div>, document.getElementById("pre-root"));
}

export default PromoMarquee;
